<template>
  <div class="form-dialog">
    <loading
      :active.sync="isLoading"
      :color="colorLoading"
      :can-cancel="false"
      :is-full-page="false"
    />

    <div class="form-body-scroll">
      <div class="form-title padding-title">
        Días Libres
      </div>
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_transferencia_text"
              v-text="text"
            />

            <!-- inicio Origen -->
            <div
              class="form_transferencia_label"
              style="padding-bottom:5px;"
              v-text="'Puerto Destino'"
            />
            <cool-select
              v-model="navyPortSelected"
              :items="navyPorts"
              :placeholder="navyPortSelected ? navyPortSelected.Nombre: 'Puerto Destino'"
              item-text="Nombre"
              @select="checkFreeDays"
            >
              <template
                slot="item"
                slot-scope="{ item: itemNavyPort }"
                class="listado-container"
              >
                <label
                  class="chip-cuenta selected"
                  @click="checkFreeDays"
                >
                  <div class="itemtest">
                    <div class="item_date_cliente">
                      Nombre: {{ itemNavyPort.Nombre }}
                      <br>
                      País: {{ itemNavyPort.País }}
                      <br>
                      Destino: {{ itemNavyPort.Destino }}
                    </div>
                  </div>
                </label>
              </template>

              <template
                slot="selection"
                slot-scope="{ item: navyPortSelected }"
              >
                <div class="item_date_cliente">
                  <b>Nombre:</b>
                  {{ navyPortSelected.Nombre }}
                  <br>
                  <b>País:</b>
                  {{ navyPortSelected.País }}
                  <br>
                  <b>Destino:</b>
                  {{ navyPortSelected.Destino }}
                </div>
              </template>
              <template slot="no-data">
                No existen datos
              </template>
            </cool-select>

            <!-- end -->
            <div
              class="form_tc_label"
              v-text="'Tipo de Carga'"
            />
            <cool-select
              v-model="loadTypeSelected"
              :items="loadType"
              :placeholder="loadTypeSelected ? loadTypeSelected : 'Tipo Carga'"
              @select="checkFreeDays"
            >
              <template
                slot="item"
                slot-scope="{ item: loadType }"
                class="listado-container"
              >
                <label
                  class="chip-cuenta selected"
                  @click="checkFreeDays"
                >
                  <div class="itemtest">
                    <div class="item_date_cliente">{{ loadType }}</div>
                  </div>
                </label>
              </template>

              <template
                slot="selection"
                slot-scope="{ item: loadTypeSelected }"
              >
                <div class="item_date_cliente">
                  {{ loadTypeSelected }}
                </div>
              </template>
              <template slot="no-data">
                No existen datos
              </template>
            </cool-select>

            <div
              class="form_tc_label"
              v-text="'Naviera'"
            />
            <cool-select
              v-model="shippingCompanySelected"
              :items="shippingCompany"
              :placeholder="shippingCompanySelected ? shippingCompanySelected : 'Naviera'"
              @select="checkFreeDays"
            >
              <template
                slot="item"
                slot-scope="{ item: shippingCompany }"
                class="listado-container"
              >
                <label class="chip-cuenta selected">
                  <div class="itemtest">
                    <div class="item_date_cliente">{{ shippingCompany }}</div>
                  </div>
                </label>
              </template>

              <template
                slot="selection"
                slot-scope="{ item: shippingCompanySelected }"
              >
                <div class="item_date_cliente">
                  {{ shippingCompanySelected }}
                </div>
              </template>
              <template slot="no-data">
                No existen datos
              </template>
            </cool-select>

            <div v-if="navyPortSelected && loadTypeSelected && shippingCompanySelected">
              <div class="form_tc_label">
                Días Libres {{ freeDays }}
              </div>
            </div>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Aplicar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/comment-dots'
import 'vue-awesome/icons/calendar-alt'
import 'vue-awesome/icons/credit-card'
import 'vue-awesome/icons/dollar-sign'
import 'vue-awesome/icons/cash-register'
import 'vue-awesome/icons/briefcase'
import 'vue-awesome/icons/euro-sign'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { CoolSelect } from 'vue-cool-select'

export default {
  components: {
    CoolSelect,
    Loading
  },
  props: {},
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      navyPorts: [],
      navyPortSelected: '',
      loadType: [],
      loadTypeSelected: '',
      shippingCompany: [],
      shippingCompanySelected: '',
      freeDays: '',
      colorLoading: '#008c94',
      isLoading: false
    }
  },
  computed: {
    combined () {
      return (
        this.navyPortSelected && this.loadType && this.shippingCompanySelected
      )
    }
  },
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'DiasLibresForm') return
      if (e.evento === 'init') {
        // console.log("asigna por init:");
        // console.log("e.dato:",e.dato);
      }
      if (e.evento === 'newdata') {
        // console.log("asigna por newdata:");
        // console.log("e.dato:", e.dato);
        this.title = e.dato.title ? e.dato.title : 'Días Libres'
        this.navyPorts = e.dato.field.navyPorts ? e.dato.field.navyPorts : []
        this.navyPortSelected = ''

        this.loadType = e.dato.field.loadType ? e.dato.field.loadType : []
        this.loadTypeSelected = ''

        this.shippingCompany = e.dato.field.shippingCompany
          ? e.dato.field.shippingCompany
          : []
        this.shippingCompanySelected = ''
      }
      if (e.evento === 'updatedata') {
        if (e.dato.type === 'form-get-data') {
          this.freeDays = e.dato.data.freeDays
          this.isLoading = false
        }
      }
    })
  },
  methods: {
    checkFreeDays () {
      this.errormsg = ''
      this.serieSel = null
      if (
        this.navyPortSelected &&
        this.loadTypeSelected &&
        this.shippingCompanySelected
      ) {
        const dataToSend = {
          form: 'DiasLibresForm',
          evento: 'sentClick',
          data: {
            getData: true,
            datatype: 'diaslibres',
            form: 'DiasLibresForm',
            fields: {
              navyPort: this.navyPortSelected,
              loadType: this.loadTypeSelected,
              shippingCompany: this.shippingCompanySelected
            }
          }
        }
        this.isLoading = true
        serverUI.$emit('FormEvent', dataToSend)
      }
    },
    _clearError () {
      this.errormsg = ''
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.navyPortSelected) {
        this.errormsg = 'Debes seleccionar un puerto'
        return
      }
      if (!this.loadTypeSelected) {
        this.errormsg = 'Debes seleccionar un tipo de carga'
        return
      }
      if (!this.shippingCompanySelected) {
        this.errormsg = 'Debes seleccionar una naviera'
        return
      }
      const dataToSend = {
        form: 'DiasLibresForm',
        evento: 'sentClick',
        data: {
          fields: {
            navyPort: this.navyPortSelected,
            loadType: this.loadTypeSelected,
            shippingCompany: this.shippingCompanySelected,
            freeDays: this.freeDays
          }
        }
      }

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'DiasLibresForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form-box-body {
  height: 310px;
}
.input {
  width: 180px;
}
</style>
<style>
.IZ-select .IZ-select__menu {
  width: 270px !important;
}

.IZ-select__menu-items {
  margin: -3% 0 3% 8%;
  max-height: none !important;
}

.IZ-select__input-wrap {
  font-size: 20px;
}

.IZ-select .IZ-select__input-wrap .IZ-select__input input {
  background: url(../src/assets/arrow_select.png) no-repeat 97% center #ecefef;
  width: 220px !important;
  height: 35px !important;
  background-color: #ecefef;
  margin: 0 0 0 20px !important;
  border: 0;
  height: 35px;
  -webkit-box-flex: 0;
  -ms-flex: none;
  flex: none;
  -webkit-appearance: button;
  border-radius: 25px;
  padding: 0 5%;
  background-size: 10%;
  cursor: pointer;
  outline: none;
  margin: 5px 0 15px 20px !important;
  font-size: 13px !important;
}

.IZ-select {
  outline: none;
  box-sizing: content-box !important;
}
</style>
